export default "__VITE_ASSET__e5c4cfc6__"